<template>
  <div class="fill-height">
    <line-chart
      v-if="viewMode === 'chart'"
      class="fill-height"
      :raw-data="stats"
      y-value-prefix="stats."
      x-value="date"
      :chart-value-keys="chartValueKeys"
      :yaxis="yAxisConfig"
      :colors="['#26E18E', '#F62424']"
    >
      <template v-slot:header>
        <v-card-title class="pa-6 d-flex justify-space-between">
          <div class="subtitle-2 grey--text text--grey-100">
            {{ $t('card_title.mood_stress') }}
          </div>
          <v-btn
            v-if="removable"
            icon
            style="pointer-events: auto"
            @click="$emit('remove')"
          >
            <v-icon small>
              fal fa-times
            </v-icon>
          </v-btn>
          <visual-list-toggle
            v-else
            :value.sync="viewMode"
          />
        </v-card-title>
      </template>
    </line-chart>

    <v-card
      v-else-if="viewMode === 'table'"
      class="fill-height rounded-lg"
    >
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t('card_title.mood_stress') }}
        </div>
        <div class="d-flex align-center">
          <visual-list-toggle
            v-if="!removable"
            :value.sync="viewMode"
          />
        </div>
      </v-card-title>

      <v-data-table
        :headers="tableHeaders"
        :items="stats"
        hide-default-footer
        disable-pagination
        :items-per-page="-1"
        fixed-header
        dense
        :height="350"
      >
        <template v-slot:item.date="{ item }">
          {{ formatDate(item.date) }}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'
import VisualListToggle from '@/components/buttons/VisualListToggle.vue'

export default {
  name: 'PlayerMoodStressChart',
  components: { LineChart, VisualListToggle },
  props: {
    stats: {
      type: Array,
      required: true,
      default: () => []
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    viewMode: 'chart'
  }),
  computed: {
    chartValueKeys() {
      return [
        {
          key: 'MOO',
          label: this.$t('variables.MOO.long'),
          type: 'line'
        },
        {
          key: 'STL',
          label: this.$t('variables.STL.long'),
          type: 'line'
        }
      ]
    },
    yAxisConfig() {
      return [
        {
          min: 0,
          max: 5,
          title: {
            text: this.$t('variables.MOO.long')
          }
        },
        {
          min: 0,
          max: 5,
          title: {
            text: this.$t('variables.STL.long')
          },
          opposite: true
        }
      ]
    },
    tableHeaders() {
      return [
        {
          text: this.$t('table_headers.date'),
          value: 'date',
          sortable: true,
          width: '25%'
        },
        {
          text: this.$t('variables.MOO.long'),
          value: 'stats.MOO',
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('variables.STL.long'),
          value: 'stats.STL',
          sortable: true,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleDateString()
    }
  }
}
</script>
